<template>
    <div>
        <div class="event-header">
            <div class="icon-common size28-21"></div>
            <div class="c-blue pl3 fz14 fw700 fg-1">Minglepass Event</div>
            <button class="icon-event-list" @click="$router.push('/event')"></button>
        </div>
        <event-detail-component :event-type="'eventDetail'" :event-key="eventKey"></event-detail-component>
        <share-modal></share-modal>
    </div>
</template>


<script>
import PageHeader from "@/components/PageHeader.vue";
import { mapState } from "vuex";
import alertMixins from "@/mixins/alertMixins";
import EventDetailComponent from "@/components/event/EventDetailComponent.vue";
import ShareModal from '@/components/modal/ShareModal.vue';

export default {
    name: "EventDetail",
    mixins: [alertMixins],
    components: {
        EventDetailComponent,
        PageHeader,
        ShareModal,
    },
    props: {},
    data() {
        return {
            eventKey: this.$route.params.idx,
        };
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeUnmount() {},
    unmounted() {},
    computed: {
        ...mapState({
            UserInfo: (state) => state.userInfo.UserInfo,
        }),
    },
    methods: {},
    watch: {},
};
</script>
